import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';
import { last } from '@angular/router/src/utils/collection';

type RoutineType = Array<{id: string, title: string, isThatDay: boolean, startDate: Date, actualDate: number, lastSuccess: number, allSuccess: number, start: number, end: number, duration: number, timeInterval: number, frequency: number, state: number, settings: number, orderNumber: number, intervals: IntervalType}>;
type IntervalType = Array<{dateStart: Date, dateEnd: Date, count: number, state: number}>;

@Injectable()
export class RoutineService {
  isLoaded: boolean = false;
  isActual: boolean = false;
  isSmallDevice: boolean = true;

  routines: RoutineType;

  colors = ["white","yellow","green","light-blue","dark-blue","pink","red"];
  colorsName = ["Bílá","Žlutá","Zelená","Světle modrá","Tmavě modrá","Růžová","Červená"];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private http: HttpClient, private authService: AuthService) { 
    if(window.screen.width > 1200) this.isSmallDevice = false;
  }

  getRoutines(){
    this.authService.notify = "";
    let params = {
      "idUser": localStorage.getItem("idUser")
    }

    this.http.post(this.authService.databaseURL+'getdata.php?table=routines', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.routines = data;
        this.isActual = true;
        this.isLoaded = true;
        for(let i = 0; i < data.length; i++){
          this.routines[i].intervals = [];
          this.routines[i].lastSuccess = 0;
          this.routines[i].allSuccess = 0;
          this.routines[i].isThatDay = false;
          let forTill = data[i].data.length;
          if(forTill > data[i].actualDate){
            forTill = data[i].actualDate;
            forTill++;
          }
          if(this.routines[i].timeInterval == 1){
            if((Number(this.routines[i].actualDate)+1)%7 == 0){
              this.routines[i].actualDate = this.routines[i].actualDate/7;
              this.routines[i].isThatDay = true;
            }
          }
          else if(this.routines[i].timeInterval == 2){
            if((Number(this.routines[i].actualDate)+1)%30 == 0){
              this.routines[i].actualDate = this.routines[i].actualDate/30;
              this.routines[i].isThatDay = true;
            }
          }

          if(data[0].day > 15){

          }          

          for(let j = 0; j < forTill; j++){
            let start = new Date(data[i].year, data[i].month, data[i].day);
            let end = new Date(data[i].year, data[i].month, data[i].day);

            if(this.routines[i].timeInterval == 2){
              if(data[0].day > 15){
                if(data[0].day-1 == new Date().getDate()){
                  start = new Date(data[i].year, data[i].month, data[i].day-1);
                  end = new Date(data[i].year, data[i].month, data[i].day-1);
                }
              } 
              else{
                if(data[0].day == new Date().getDate()+1){
                  start = new Date(data[i].year, data[i].month, data[i].day-1);
                  end = new Date(data[i].year, data[i].month, data[i].day-1);
                }
              }
              
  
            } 

            if(this.routines[i].timeInterval == 0){
              start.setDate(start.getDate() + j);
              end.setDate(end.getDate() + j);      
            }
            else if(this.routines[i].timeInterval == 1){
              start.setDate(start.getDate() + (j * 7));
              end.setDate(end.getDate() + (j * 7)+6);
              if(new Date() > start && new Date() < end){
                this.routines[i].actualDate = j;
              }
              
            }
            else{
              start.setMonth(start.getMonth() + j);
              end.setMonth(end.getMonth() + j + 1);
              end.setDate(end.getDate()-1);

              if(new Date() > start && new Date() < end){
                this.routines[i].actualDate = j;

              }
            }

            if(Number(this.routines[i].actualDate < 5)){
              this.routines[i].start = 0;
              this.routines[i].end = 5;
            }
            else if(Number(this.routines[i].actualDate) > Number(this.routines[i].duration)){
              this.routines[i].start = this.routines[i].duration-5;
              this.routines[i].end = this.routines[i].duration;
            }
            else if(Number(this.routines[i].actualDate) == Number(this.routines[i].duration)){
              this.routines[i].start = this.routines[i].duration-4;
              this.routines[i].end = Number(this.routines[i].duration)+1;
            }
            else{
              this.routines[i].start = this.routines[i].actualDate-4;
              this.routines[i].end = Number(this.routines[i].actualDate)+1;
            }

            let rouState = 1;
            if(data[i].data[j] == this.routines[i].frequency){
              rouState = 2;
            }
            else if(data[i].data[j] == 0){
              rouState = 0;
            }            
            let newTerm = {
              dateStart: start,
              dateEnd: end,
              count: data[i].data[j],
              state: rouState
            }
            
            if(start > new Date() && this.routines[i].timeInterval > 0){

            }
            else{
            }
            this.routines[i].intervals.push(newTerm);
            
          }

          this.returnAllSuccess(i);
          this.returnLastSuccess(i);
        }
      },
      error => this.isActual = false
    )
    
    return this.routines;
  }

  addRoutine(routine){
    this.authService.notify = "";
    let params = {
      "id": "R" + Date.now() + "-" + localStorage.getItem("idUser").slice(-10),
      "title": routine.title,
      "frequency": routine.frequency,
      "duration": routine.duration,
      "timeInterval": routine.timeInterval,
      "startDate": routine.startDate,
      "data": '',
      "settings": Number(routine.settings),
      "orderNumber": (this.routines.length+1),
      "idUser": localStorage.getItem("idUser"),
      "state": 0
    }
  
    for(let i = 0; i < params.duration; i++){
      params.data += "0";
    }

    let offParams = {
      "id": params.id,
      "title": params.title,
      "frequency": params.frequency,
      "duration": params.duration,
      "timeInterval": params.timeInterval,
      "startDate": params.startDate,
      "start": 0,
      "end": 5,
      "isThatDay": false,
      "lastSuccess": 0,
      "allSuccess": 0,
      "actualDate": 5,
      "intervals": [],
      "settings": params.settings,
      "orderNumber": params.orderNumber,
      "state": 0
    }

    //this.routines.push(offParams);

    this.http.post(this.authService.databaseURL+'adddata.php?table=routine', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.getRoutines();
      },
      error => {
        this.authService.notify = "Rutina nebyla přidána. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
    
  }

  updateRoutine(editedRoutine,editedRoutineID){ 
    this.authService.notify = "";
    this.http.post(this.authService.databaseURL+'updatedata.php?table=routine', editedRoutine, this.httpOptions).subscribe(
      (data:any[]) => {
        this.routines[editedRoutineID].title = editedRoutine.title;
        this.routines[editedRoutineID].settings = editedRoutine.settings;

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }
  activityPlus(i,j){
    this.routines[i].intervals[j].count++;
    if(this.routines[i].intervals[j].count == this.routines[i].frequency){
      this.routines[i].intervals[j].state = 2;
    }
    else{ 
      this.routines[i].intervals[j].state = 1;
    }
    this.returnAllSuccess(i);
    this.returnLastSuccess(i);
    this.updateRoutineData(i);

  }
  activityNull(i,j){
    this.routines[i].intervals[j].state = 0;
    this.routines[i].intervals[j].count = 0;
    this.returnAllSuccess(i);
    this.returnLastSuccess(i);
    this.updateRoutineData(i);

  }
  routineOlder(i){
    this.routines[i].start = this.routines[i].start-5;
    this.routines[i].end = this.routines[i].end-5;
    if(this.routines[i].start < 0){
      this.routines[i].start = 0;
      this.routines[i].end = 5;
    }
  }
  routineNewer(i){
    this.routines[i].start = Number(this.routines[i].start)+5;
    this.routines[i].end = Number(this.routines[i].end)+5;
    if(this.routines[i].end > this.routines[i].actualDate){
      this.routines[i].start = this.routines[i].actualDate-4;
      this.routines[i].end = Number(this.routines[i].actualDate)+1;
    }
    else if(this.routines[i].end > this.routines[i].duration){
      this.routines[i].start = this.routines[i].duration-5;
      this.routines[i].end = this.routines[i].duration;
    }
  }

  returnLastSuccess(i){
   let lastSuc = 0;
    let forStart = 0;
    let forTill = this.routines[i].intervals.length;
    if(forTill > this.routines[i].actualDate){
      forTill = this.routines[i].actualDate;
      forTill++;
    }
    if(this.routines[i].isThatDay == true){
      forTill = Math.ceil(forTill%7);
      forTill--;
    }
    else if(this.routines[i].isThatDay == true && this.routines[i].timeInterval == 2){
      forTill = Math.ceil(forTill%30);
      forTill--;
    }
    forStart = forTill;
    if(forStart < 5){
      forStart = 5;
    }
    
    for(let j = forStart-5; j < forTill; j++){
        lastSuc = Number(lastSuc) + Number(this.routines[i].intervals[j].count);     
    }
    this.routines[i].lastSuccess = (100/(this.routines[i].frequency*5))*lastSuc;
  }

  returnAllSuccess(i){
    let allSuc = 0;
    let forTill = this.routines[i].intervals.length;
    if(forTill > this.routines[i].actualDate){
      forTill = this.routines[i].actualDate;
      forTill++;
    }
    if(this.routines[i].isThatDay == true && this.routines[i].timeInterval == 1){
      forTill = Math.ceil(forTill%7);
      forTill--;
    }
    else if(this.routines[i].isThatDay == true && this.routines[i].timeInterval == 2){
      forTill = Math.ceil(forTill%30);
      forTill--;
    }
    for(let j = 0; j < forTill; j++){
      allSuc = allSuc + Number( this.routines[i].intervals[j].count);
    }
    this.routines[i].allSuccess = (100/(this.routines[i].frequency*forTill))*allSuc;
  }

  updateRoutineData(i){ 
    this.authService.notify = "";
    let data = "";
    for(let j = 0; j < this.routines[i].duration; j++){
      if(this.routines[i].intervals.length > j){
        data += this.routines[i].intervals[j].count;
      }
      else data += "0";
      
    }

    let params = {
      "idUser": localStorage.getItem("idUser"),
      "id": this.routines[i].id,
      "data": data
    }
    

    this.http.post(this.authService.databaseURL+'updatedata.php?table=routinedata', params, this.httpOptions).subscribe(
      (data:any[]) => {

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  removeRoutine(i, id){
    this.authService.notify = "";   
    let routine = {
      "id": id,
      "idUser": localStorage.getItem("idUser"),
      "orderNumber": this.routines[i].orderNumber
    }
    this.http.post(this.authService.databaseURL+'removedata.php?table=routine', routine, this.httpOptions).subscribe(
      (data:any[]) => {

        for(let x = i; x < this.routines.length; x++){
          this.routines[x].orderNumber--;
        }
        this.routines.splice(i,1);
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  changeOrder(newOrderNumber){
    this.authService.notify = "";
    if(this.isActual == false) return;

    let shiftDown = true;
    let shiftedItem = newOrderNumber;
    for(let i = 0; i < this.routines.length; i++){
      if((i+1) == this.routines[i].orderNumber){
        
      }
      else{
        shiftedItem = i + 1;
        if(this.routines[i].orderNumber > newOrderNumber) {
          shiftedItem = this.routines[i].orderNumber;
          shiftDown = false;
        }
        break;
      }
    }
    if(shiftDown == newOrderNumber){

    }
    else if(shiftDown == true){
      for(let i = shiftedItem-1; i < newOrderNumber; i++){
        this.routines[i].orderNumber--;
      }
      this.routines[newOrderNumber-1].orderNumber = newOrderNumber;

      let routinesInfo = {
        "fromList":  shiftedItem,
        "toList": newOrderNumber,
        "orderItemID": this.routines[newOrderNumber-1].id,
        "idUser": localStorage.getItem("idUser"),
      }

      this.http.post(this.authService.databaseURL+'updatedata.php?table=routineorderdown', routinesInfo, this.httpOptions).subscribe(
        (data:any[]) => {

        },
        error => {
          this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
          this.isActual = false;
        }
      );

    }
    else{
      for(let i = newOrderNumber-1; i < shiftedItem; i++){
        this.routines[i].orderNumber++;
      }
      this.routines[newOrderNumber-1].orderNumber = newOrderNumber;

      let routinesInfo = {
        "fromList":  shiftedItem,
        "toList": newOrderNumber,
        "orderItemID": this.routines[newOrderNumber-1].id,
        "idUser": localStorage.getItem("idUser"),
      }

      this.http.post(this.authService.databaseURL+'updatedata.php?table=routineorderup', routinesInfo, this.httpOptions).subscribe(
        (data:any[]) => {

        },
        error => {
          this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
          this.isActual = false;
        }
      );

    }
  }
  orderUp(i){
    let orderInfo = {
      "thisItemID":  this.routines[i].id,
      "nextItemID": this.routines[i-1].id,
      "thisItemOrder":  this.routines[i].orderNumber,
      "nextItemOrder": this.routines[i-1].orderNumber,
      "idUser": localStorage.getItem("idUser")
    }

    let swapArray = this.routines[i]; 
    this.routines[i] = this.routines[i-1];
    this.routines[i-1] = swapArray;

    let swapOrderNumber = this.routines[i].orderNumber;
    this.routines[i].orderNumber = this.routines[i-1].orderNumber;
    this.routines[i-1].orderNumber = swapOrderNumber;
    
    this.http.post(this.authService.databaseURL+'updatedata.php?table=routinesorder', orderInfo, this.httpOptions).subscribe(
      (data:any[]) => {

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }
  orderDown(i){
    let orderInfo = {
      "thisItemID":  this.routines[i].id,
      "nextItemID": this.routines[i+1].id,
      "thisItemOrder":  this.routines[i].orderNumber,
      "nextItemOrder": this.routines[i+1].orderNumber,
      "idUser": localStorage.getItem("idUser")
    }

    let swapArray = this.routines[i]; 
    console.log(swapArray);
    this.routines[i] = this.routines[i+1];
    this.routines[i+1] = swapArray;

    let swapOrderNumber = this.routines[i].orderNumber;
    this.routines[i].orderNumber = this.routines[i+1].orderNumber;
    this.routines[i+1].orderNumber = swapOrderNumber;
    
    this.http.post(this.authService.databaseURL+'updatedata.php?table=routinesorder', orderInfo, this.httpOptions).subscribe(
      (data:any[]) => {

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/routine.service.ts